import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
  create(name) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          createDomain (
            name: "${name}"
          ) {
            id,
            name,
            dkim_code,
            created_at,
            updated_at,
            brevo_code,
            authenticated,
            dkim_host_name,
            dkim_validated,
            brevo_host_name,
            brevo_validated
          }
        }
      `
    });
  },
  fetch: (sortName = "created_at", page, itemsPerPage, type = "DESC", word = "") => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', formatGraphqlBody(
      'query',
      'getDomains',
      {
        0: 'pagination_page',
        1: 'pagination_limit',
        2: 'total_pages',
        3: 'total_items',
        items: {
          0: 'id',
          1: 'name',
          2: 'dkim_code',
          3: 'created_at',
          4: 'updated_at',
          5: 'brevo_code',
          6: 'authenticated',
          7: 'dkim_host_name',
          8: 'dkim_validated',
          9: 'brevo_host_name',
          10: 'brevo_validated'
        }
      },
      {
        orderBy: [sortName, type],
        search_filter: word,
        pagination_page: page,
        pagination_limit: itemsPerPage
      }
    ));
  },
  delete(name) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          deleteDomain (
            name: "${name}"
          )
        }
      `
    });
  },
  auth(name) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          authDomain (
            name: "${name}"
          )
        }
      `
    });
  },
  validate(name) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          validateDomain (
            name: "${name}"
          ) {
            brevo_validated,
            dkim_validated
          }
        }
      `
    });
  },
}